import { FreightRate } from "../models/freight-rate.model";
import { RateLocation } from "../../../rate/rate-location/rate-location.type";
import { ITableColumn } from "app/ui/table/table-column.interface";
import { OnlineCarrierAction } from "app/rate/online-carrier.interface";

export class FreightRateGroup {
  constructor(
    public groupName: string,
    public quoteOriginLocationId?: number,
    public quoteDestinationLocationId?: number,
    public originLocation?: RateLocation,
    public destinationLocation?: RateLocation,
    public freightRates?: FreightRate[],
    public selection?: FreightRate[],
    public newFreightRate?: FreightRate,
    // The lane may query online carriers at all; which ones is the backend's call.
    public canLoadOnlineRates = false,
    public onlineCarriers: OnlineCarrierAction[] = [],
    public canLoadPartnerOnlineRates = false,
    public loadingPartnerOnlineRates = false,
    public discriminator?: string,
    public kind?: string,
    public columns?: ITableColumn[],
    // Both halves of groupName, split once when the groups are built so the
    // header does not re-split it on every change-detection pass.
    public originLabel?: string,
    public destinationLabel?: string,
  ) {}
}
